
























































import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { NoCache } from '../decorators'

import PageTitle from '@/components/PageTitle.vue'  // @ is an alias to /src
import EditMeterModal from '@/components/EditMeterModal.vue'

import Meter from '@/services/models/meter'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    PageTitle,
    EditMeterModal,
  },
})
export default class Meters extends Vue {

  @Getter('firestore/meters')
  public meters!: Meter[]

  @Action('firestore/fetchMeters')
  public fetchMeters!: () => Promise<Meter>

  public formatters = formatters

  public mounted() {
    this.fetchMeters()
  }

  @NoCache
  public get editingMeterModal(): EditMeterModal {
    return this.$refs.editingMeterModal as EditMeterModal
  }

  public onMeterCommitted(meter: Meter) {
    //
  }
}
